var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.formatIcon,{tag:"component",attrs:{"theme":_vm.theme,"size":_vm.size,"fill":_vm.fill,"stroke-width":_vm.strokeWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }